<template>
  <vs-popup class="order-item-document-popup"
            background-color-popup="danger"
            background-color="danger"
            :title="'PRODUCT ' + item.formulation_code"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card  no-shadow>

      <div class="vx-row" v-if="!(sdsExists || techSpecExists || coaExists || coshExists)">
        <div class="vx-col w-full">
          No documents available.
        </div>
      </div>

      <div class="vx-row" v-if="sdsExists || techSpecExists || coaExists || coshExists">
        <div class="vx-col w-full">
          <H4>Documents Available</H4>
        </div>
      </div>

     <div class="vx-row" v-if="sdsExists || techSpecExists || coaExists || coshExists">
       <div class="vx-col w-full">
         <vs-table noDataText="">

           <template slot="thead">
             <vs-th width="50%"></vs-th>
             <vs-th width="50%">Action</vs-th>
           </template>



           <template slot-scope="{data}">

<!--             <vs-tr v-if="sdsExists">-->
             <vs-tr v-if="sdsExists">
               <vs-td>SDS</vs-td>
               <vs-td>
                   <vs-button @click="onClickDownloadSds" class="" size="small" color="primary" type="border" icon-pack="feather" icon="icon-download">Download</vs-button>
               </vs-td>
             </vs-tr>

             <vs-tr v-if="techSpecExists">
               <vs-td>Tech Specification</vs-td>
               <vs-td>
                   <vs-button @click="onClickDownloadFormulationDocs('Tech Specification')" class="" size="small" color="primary" type="border" icon-pack="feather" icon="icon-download">Download</vs-button>
               </vs-td>
             </vs-tr>

             <vs-tr v-if="coaExists" v-for="(wo , wo_index) in item.inventory_stock" :key="wo_index">
               <vs-td>CoA {{ wo_index+1 }} ( {{ wo.work_order_code }} )</vs-td>
               <vs-td>
                <div class="vx-row">
                  <vs-button @click="onClickDownloadCoa(wo.work_order_id)"
                            :disabled="wo.work_order_qc_status !== 'Approved by QC'"
                            class="" size="small" color="primary" type="border" icon-pack="feather" icon="icon-download">
                   {{ wo.work_order_qc_status === 'Approved by QC' ? 'Download' : 'QC not approved' }}
                 </vs-button>
                 <vs-button @click="onClickSendCoaEmail(wo.work_order_id)"
                            class="ml-2" size="small" color="warning" type="border" icon-pack="feather" icon="icon-send">
                   Send
                 </vs-button>
                </div>
               </vs-td>
             </vs-tr>
             <vs-tr v-if="coshExists" v-for="(cu , cu_index) in item.courier_shipments" :key="cu_index">
               <vs-td>Delivery Note ( {{ cu.courier_shipment_code}} )</vs-td>
               <vs-td>
                <div class="vx-row">
                  <vs-button @click="onClickDownloadCosH(cu.id)"
                            class="" size="small" color="primary" type="border" icon-pack="feather" icon="icon-download">
                   Download
                 </vs-button>
                 <vs-button @click="onClickSendDeliveryNote(cu.id)"
                            class="ml-2" size="small" color="warning" type="border" icon-pack="feather" icon="icon-send">
                   Send
                 </vs-button>
                </div>
               </vs-td>
             </vs-tr>

<!--             <vs-tr v-if="checkCofaExists()">-->
<!--               <vs-td>CofA</vs-td>-->
<!--               <vs-td>-->
<!--                 <vs-button @click="onClickDownloadCofa()" class="" size="small" color="primary" type="border" icon-pack="feather" icon="icon-download">Download</vs-button>-->
<!--               </vs-td>-->
<!--             </vs-tr>-->

           </template>

         </vs-table>
       </div>
     </div>


    </vx-card>
    <product-order-cofa-document-pop-up ref="productOrderCofaDocumentPopUp"/>
    <product-order-sds-pop-up v-on:onClickCloseDocs="onClickCloseDocs()" ref="productOrderSdsPopUp"/>
    <product-order-sds-u-l-document-pop-up ref="productOrderSdsULDocumentPopUp"/>
    <!-- <shipment-delivery-note-pdf-pop-up ref="ShipmentDeliveryNotePdfPopUp"/> -->
    <DeliveryNote ref="deliveryNotePopUp"/>

    <vs-prompt
      @cancel="customer_email=''"
      @accept="sendDocuments"
      @close="activePrompt = false"
      :title="'Select customer user email to send'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Select user email</span>
        <v-select
          :clearable="true" name="customerId" placeholder=""
          v-model="customer_email"
          label="email"
          :options="customer_list"
          :reduce="option => option.email"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
      </div>
    </vs-prompt>

  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const FormulationsRepository = RepositoryFactory.get('formulations')
  const CustomerRepository = RepositoryFactory.get('customer')
  const DropDownRepository = RepositoryFactory.get('drop_down')
  const CourierRepository = RepositoryFactory.get('courier')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import ProductOrderCofaDocumentPopUp
    from "@/components/popups/customer/product-orders/documents/ProductOrderCofaDocumentPopUp";
  import ProductOrderSdsPopUp from "@/components/popups/customer/product-orders/documents/ProductOrderSdsPopUp";
  import ProductOrderSdsULDocumentPopUp
    from "@/components/popups/customer/product-orders/documents/ProductOrderSdsULDocumentPopUp";
  import ShipmentDeliveryNotePdfPopUp from "../../courier/courier-shipment/documents/ShipmentDeliveryNotePdfPopUp";
  import DeliveryNote from '@/components/popups/pdf/DeliveryNote.vue'


  function initialState() {
    return {
      open: false,
      item: {
        inventory_stock: [],
        courier_shipments: [],
        work_orders: []
      },
      product_catalogue_info: {
        documentation: [],
        sds_documents: []
      },
      formulation_type: '',
      formulation_code: '',
      customerId: '',
      activePrompt: false,
      customer_list: [],
      customer_email: '',
      selected_wo : '',
      selected_shipment: '',
      selected_send_function: ''
    }
  }

export default {
  name: 'ProductOrderItemDocumentPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (item, customerId) {
      try {
        await Object.assign(this.$data, initialState())
        this.item = item
        this.customerId = customerId
        await this.loadFormulations()
        this.open = true;
      } catch (error) {

      }
    },
    onClickCloseDocs() {
      this.open = true
    },
    onClickDownloadCofa() {
      let word_orders = []
      Object.assign(word_orders, this.item.work_orders)
      let arr = word_orders.filter((x) => {
        return x.qc_status === 'Approved by QC' && x.status === 'Pack Off Completed'
      })
      this.$refs.productOrderCofaDocumentPopUp.openPopup(arr[arr.length - 1].id, this.formulation_type)
    },
    onClickDownloadSds() {
      window.open(this.product_catalogue_info.sds_documents[this.product_catalogue_info.sds_documents.length - 1].file,  '_blank')
      // this.$refs.productOrderSdsULDocumentPopUp.openPopup(this.formulation_code)
    },
    onClickDownloadCosH(id){
      this.$refs.deliveryNotePopUp.openPopup(id, this.customerId)
    },
    onClickDownloadFormulationDocs(doc_type) {
      try {
        this.open = false
        const documents = this.product_catalogue_info.documentation.filter((x) => x.name === doc_type)
        this.$refs.productOrderSdsPopUp.openPopup(documents, doc_type)
      }  catch (e) {

      }
    },
    onClickDownloadCoa(wo_id) {
      this.$refs.productOrderCofaDocumentPopUp.openPopup(wo_id, this.item.formulation_type, this.customerId)
    },
    checkCofaExists() {
      if(this.item.work_orders.length === 0 ) {
        return false
      }
      if(this.item.work_orders.length === 1 && this.item.work_orders[0].qc_status === 'Approved by QC' && this.item.work_orders[0].status === 'Pack Off Completed') {
        return true
      }
      if(this.item.work_orders.length > 1) {
        let count = 0
        this.item.work_orders.forEach((x) => {
          if(x.qc_status === 'Approved by QC' && x.status === 'Pack Off Completed') {
            count++
          }
        })
        return count !== 0
      } else {
        return false
      }
    },
    async loadFormulations() {
      await this.$vs.loading()
      const {data} = await FormulationsRepository.details(this.item.formulation_id)
      this.formulation_code = data.data.formulation_code
      this.formulation_type = data.data.formulation_type
      this.product_catalogue_info =  data.data.documents
      this.$vs.loading.close()
    },
    async sendDocuments() {
      if(this.selected_send_function === 'coa') {
        await this.sendCoaEmail()
      }
      if(this.selected_send_function === 'shipment') {
        await CourierRepository.sendShipmentDocument(this.selected_shipment, { user_email: this.customer_email})
        this.showSuccessMessage('Delivery note send successfully!')
        this.open = true
        this.activePrompt = false
      }
    },
    async onClickSendCoaEmail(wo_id) {
        try {
          this.selected_wo = wo_id
          this.selected_send_function = 'coa'
          const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.customerId)).data
          this.customer_list = data
        } catch (e) {

        }
        this.open = false
        this.activePrompt = true
      },
    async sendCoaEmail() {
      try {
        this.open = true
        this.activePrompt = false
        await FormulationsRepository.sendProductCoaEmail(
          this.selected_wo, this.formulation_type, { customer_id: this.customerId, user_email: this.customer_email }
        )
        this.showSuccessMessage('COA send successfully!')
      } catch(e) {

      }
    },
    async onClickSendDeliveryNote(shipment_id) {
      this.selected_shipment = shipment_id
      this.selected_send_function = 'shipment'
      try {
        const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.customerId)).data
        this.customer_list = data
        this.open = false
        this.activePrompt = true
      } catch (error) {
        
      }
    }
  },
  computed: {
    sdsExists: function () {
      if(this.product_catalogue_info && Array.isArray(this.product_catalogue_info.sds_documents)) {
        return this.product_catalogue_info.sds_documents.length > 0
      } else {
        return false
      }
    },
    techSpecExists: function () {
      if(this.product_catalogue_info && Array.isArray(this.product_catalogue_info.documentation)) {
        const textSpecs = this.product_catalogue_info.documentation.filter((x) => x.name === 'Tech Specification')
        return textSpecs.length > 0
      } else {
        return false
      }
    },
    coaExists: function () {
      return !!this.item && Array.isArray(this.item.inventory_stock) && this.item.inventory_stock.length > 0
    },
    coshExists: function (){
      return !!this.item && Array.isArray(this.item.courier_shipments) && this.item.courier_shipments.length > 0
    }
  },
  components: {
    ShipmentDeliveryNotePdfPopUp,
    'v-select': vSelect,
    ProductOrderCofaDocumentPopUp,
    ProductOrderSdsPopUp,
    ProductOrderSdsULDocumentPopUp,
    DeliveryNote
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .order-item-document-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }

</style>
